module.exports = __webpack_public_path__ + "img/IMG-20190905-WA0028.2672df14.jpg";